import { useEffect, useState } from 'react';

import { Page } from 'react-pdf';

import { HighlightCanvas } from '../highlight-canvas';
import { DocViewerLoader } from './doc-viewer-loader';
import { BoundingBoxWithId } from '@/types';

interface PDFPageProps {
  pageNumber: number;
  top: number;
  dimensions: { width: number; height: number };
  zoom: number;
  highlights: BoundingBoxWithId[];
  onHighlightClick?: (id: string) => void;
  highlightedFactId?: string | null;
  highlightedChunkId?: string | null;
  onPageLoadSuccess?: (pageNumber: number, dimensions: { width: number; height: number }) => void;
}

export const PDFPage = ({
  pageNumber,
  top,
  dimensions,
  zoom,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  onPageLoadSuccess,
}: PDFPageProps) => {
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const renderDimensions = {
    width: dimensions.width / zoom,
    height: dimensions.height / zoom,
  };

  useEffect(() => {
    setHasLoadedOnce(false);
  }, [pageNumber]);

  return (
    <div
      className="absolute shadow-lg"
      style={{
        top,
        left: '50%',
        transform: 'translateX(-50%)',
        width: dimensions.width,
        height: dimensions.height,
      }}
    >
      <HighlightCanvas
        highlights={highlights}
        pageNumber={pageNumber}
        width={dimensions.width}
        height={dimensions.height}
        highlightedFactId={highlightedFactId}
        onHighlightClick={onHighlightClick}
        highlightedChunkId={highlightedChunkId}
      />
      <div
        style={{
          width: renderDimensions.width,
          height: renderDimensions.height,
          transform: `scale(${zoom})`,
          transformOrigin: 'top left',
        }}
      >
        <Page
          pageNumber={pageNumber}
          width={renderDimensions.width}
          height={renderDimensions.height}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          loading={hasLoadedOnce ? null : <DocViewerLoader />}
          onLoadSuccess={(page) => {
            setHasLoadedOnce(true);
            const viewport = page.getViewport({ scale: 1 });
            onPageLoadSuccess?.(pageNumber, { width: viewport.width, height: viewport.height });
          }}
        />
      </div>
    </div>
  );
};
